export default function About() {
  return (
    <section id="historia" className="sec">
      <div className="wrap split about">
        <div className="letter">
          <h2 className="h2">Nossa história</h2>

          <p data-reveal>
            Nossos fundadores têm origem em Minas Gerais. Em 2019, em Curitiba, começamos como
            securitizadora, com uma ideia simples: dar às empresas que vendem a prazo uma forma ágil e
            transparente de transformar seus recebíveis em caixa.
          </p>
          <p data-reveal>
            Desde então, acompanhamos cada operação de perto, da produção até a chegada do capital em
            conta, sempre com contato direto entre as pessoas que decidem de cada lado.
          </p>
          <p data-reveal>
            Em julho de 2024 lançamos o FinTrust FIDC. Com ele, ampliamos nossa capacidade de atender
            um mercado em constante evolução e reforçamos o compromisso com o crescimento sustentável,
            nosso e dos nossos clientes.
          </p>
          <p data-reveal>
            A burocracia da securitização acontece toda no digital. O atendimento continua pessoal:
            cada área tem um contato direto, de segunda a sexta, das 8:00 às 17:30.
          </p>

          <div className="sign" data-reveal>
            <strong>Equipe FinTrust</strong>
            <span className="small muted">Securitizadora e FIDC · Curitiba, Paraná</span>
          </div>
        </div>

        <figure className="about-photo" data-reveal>
          <div className="frame" data-clip>
            <img
              className="media"
              data-parallax
              src="/images/found/pitangui-matriz-pilar.jpg"
              alt="Igreja Matriz de Nossa Senhora do Pilar, em Pitangui, Minas Gerais"
              width="1432"
              height="1100"
              loading="lazy"
              decoding="async"
            />
          </div>
          <figcaption>Matriz de Nossa Senhora do Pilar, em Pitangui, Minas Gerais, terra de origem dos nossos fundadores.</figcaption>
        </figure>
      </div>
    </section>
  );
}
